import { AlertsService } from './alerts.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  templateUrl: 'alert.component.html'
})

export class AlertComponent implements OnInit, OnDestroy {
  @Input() id!: string;

  public isVisible!: boolean;

  constructor(protected service: AlertsService) { }

  ngOnInit(): void {
    this.service.add(this);
  }

  ngOnDestroy(): void {
    this.service.remove(this.id);
  }

  show(): void {
    this.isVisible = true;
  }

  hide(): void {
    this.isVisible = false;
  }
}
